import React from "react";
import TableBase from "./Base";
import moment from "moment";
import { Tooltip } from "antd";
import { ReactSVG } from "react-svg";

import { DATETIME_SIMPLY_FORMAT_FRONTEND } from "../../constants";
import { getTranslation } from "../../utils/helper";

const MessageLogsTable = ({ scrollHeight, actionWidth, withAction, setting, ...props }) => {
  const COLUMNS = [
    {
      title: getTranslation(setting, "Message Logs", "Date/Time"),
      dataIndex: "createdAt",
      width: 150,
      ellipsis: true,
      render(value) {
        return value ? moment(value).locale(setting.systemLanguage).format(DATETIME_SIMPLY_FORMAT_FRONTEND) : "-";
      },
    },
    {
      title: getTranslation(setting, "Message Logs", "Route Plan"),
      dataIndex: "routePlan",
      width: 170,
      ellipsis: true,
      render(value) {
        return value?.name ?? "-";
      },
    },
    {
      title: getTranslation(setting, "Message Logs", "From"),
      dataIndex: "msgFrom",
      width: 100,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Message Logs", "To"),
      dataIndex: "msgTo",
      width: 120,
      ellipsis: true,
    },
    {
      title: getTranslation(setting, "Message Logs", "Message"),
      dataIndex: "msg",
      width: 350,
      ellipsis: true,
      render(message) {
        return (
          <Tooltip title={message}>
            <span>{message}</span>
          </Tooltip>
        );
      },
    },
    {
      title: getTranslation(setting, "Message Logs", "Status"),
      dataIndex: "status",
      width: 150,
      ellipsis: true,
      render(status) {
        return (
          <div className="messageLogStatus">
            <span className={"status " + status.toLowerCase()}>{getTranslation(setting, "Message Logs", status)}</span>
            {status.toLowerCase() === "undelivered" && <ReactSVG className="icon" src="/icons/undelivered.svg" />}
          </div>
        );
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: "action",
      width: actionWidth || 100,
      fixed: "right",
      render(record) {
        return withAction(record);
      },
    });
  }

  if (scrollHeight) {
    return <TableBase columns={COLUMNS} scroll={{ x: 991, y: scrollHeight }} {...props} />;
  } else {
    return <TableBase columns={COLUMNS} scroll={{ x: 991 }} {...props} />;
  }
};

export default MessageLogsTable;
